import { SVGELEMENT } from '../../../../../enums/SVGELEMENT.js';
import SVGSHAPE from '../SVGSHAPE.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
import SVGTSPAN from './SVGTSPAN.js';
// Model Structure
export const svgTextAttr = makeAttrStruct([
    ['dx'],
    ['dy'],
    ['rotate'],
    ['textLength'],
    ['lengthAdjust'],
    ['fill'],
    ['stroke'],
    ['style']
]);
export const svgTextData = makeDataStruct();
export const svgTextModel = makeStruct([
    ['attributes', svgTextAttr],
    ['data', svgTextData]
]);
// Simplified Model
export function svgText(attributes, data) {
    return {
        attributes: attributes || svgTextAttr(),
        data: data || svgTextData()
    };
}
/** Creates a Line Shape for an SVG */
export default class SVGTEXT extends SVGSHAPE {
    constructor(node, model) {
        super(node, SVGELEMENT.TEXT, model);
        this.buildSVGTSpan(model.data.children ?? []);
    }
    /** Adds a shape to this SVG Element */
    addTSpan(model) {
        return this.addChild(new SVGTSPAN(this, model));
    }
    buildSVGTSpan(vectors) {
        // if (!vectors || !Array.isArray(vectors)) {
        // 	console.warn('SVG.buildSVGTSpan: Invalid model or missing data.children', vectors);
        // 	return;
        // }
        vectors.forEach((el) => {
            switch (el.element) {
                case SVGELEMENT.TSPAN: {
                    this.addTSpan(el);
                    break;
                }
            }
        });
    }
}
